import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function VisitorToday() {
  const { visitor } = useContext(AuthContext);

  const renderDevice = (device) => {
    if (visitor !== null) {
      const total = visitor.length;
      const newDevice = visitor.filter((vis) => vis.device === device);
      const percentage = (newDevice.length / total) * 100;
      return percentage.toFixed(2) + "%";
    } else {
      return "0%";
    }
  };

  return (
    <div className="device-chart divContent darktextColor darkdivColor">
      <p className="text">
        Mobile : <b>{renderDevice("Mobile")}</b>
      </p>
      <p className="text">
        Desktop : <b>{renderDevice("Desktop")}</b>
      </p>
    </div>
  );
}

export default VisitorToday;
